var map = {
	"./layout.two-columns-2-1.html": 645,
	"./layout.two-equal-cols.html": 646,
	"./page.frontpage-parallax-full.html": 647
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;



//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets ^\.\/.*\.html$
// module id = 644
// module chunks = 0